import { createTheme } from "@mui/material";
import {
    matjungelenAmber,
    matjungelenDarkGreen,
    matjungelenLightGreen,
} from "./colors";

export const displayFontFamily = [
    "Economica",
    '"Helvetica Neue"',
    "Helvetica",
    "Arial",
    "sans-serif",
].join(",");

export const matjungelenTheme = createTheme({
    typography: {
        fontFamily: [
            '"Helvetica Neue"',
            "Helvetica",
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
        h1: {
            fontFamily: displayFontFamily,
            fontWeight: 700,
            color: matjungelenDarkGreen,
        },
        h2: {
            fontFamily: displayFontFamily,
            fontWeight: 700,
            fontSize: "clamp(2.1rem, 4vw, 2.9rem)",
            lineHeight: 1.15,
            color: matjungelenDarkGreen,
        },
        h3: {
            fontFamily: displayFontFamily,
            fontWeight: 700,
            color: matjungelenDarkGreen,
        },
        h4: {
            fontFamily: displayFontFamily,
            fontWeight: 700,
            fontSize: "2.25rem",
            color: matjungelenDarkGreen,
        },
        overline: {
            fontFamily: displayFontFamily,
            fontWeight: 700,
            fontSize: "1.35rem",
            lineHeight: 1.2,
            textTransform: "none",
            letterSpacing: 0,
            color: matjungelenDarkGreen,
        },
    },
    palette: {
        primary: {
            main: matjungelenDarkGreen,
        },
        background: {
            default: matjungelenLightGreen,
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: "999px",
                    textTransform: "none",
                    fontWeight: 400,
                    fontSize: "20px",
                    lineHeight: 1.5,
                    letterSpacing: 0,
                    paddingLeft: "28px",
                    paddingRight: "28px",
                    paddingTop: "8px",
                    paddingBottom: "8px",
                },
                contained: {
                    backgroundColor: matjungelenDarkGreen,
                    color: matjungelenAmber,
                    "&:hover": {
                        backgroundColor: "#0c2c17",
                    },
                },
                outlined: {
                    borderWidth: "1.5px",
                    borderColor: matjungelenDarkGreen,
                    color: matjungelenDarkGreen,
                    "&:hover": {
                        borderWidth: "1.5px",
                        borderColor: matjungelenDarkGreen,
                        backgroundColor: "rgba(18, 63, 34, 0.06)",
                    },
                },
                text: {
                    color: matjungelenDarkGreen,
                    textDecoration: "underline",
                    fontSize: "16px",
                    fontWeight: 400,
                    lineHeight: "20px",
                    padding: "2px 6px",
                    "&:hover": {
                        textDecoration: "underline",
                        backgroundColor: "rgba(18, 63, 34, 0.06)",
                    },
                },
            },
        },
        MuiRadio: {
            styleOverrides: {
                root: {
                    color: matjungelenDarkGreen,
                },
            },
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    color: matjungelenDarkGreen,
                    textDecorationColor: matjungelenDarkGreen,
                },
            },
        },
    },
});
